<template>
  <BorderStyle class="bc500-chart">
    <v-chart :options="option" :autoresize="true" />
  </BorderStyle>
</template>

<script>
import BorderStyle from './border-style.vue';

export default {
  components: { BorderStyle },
  props: {
    title: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    serieStyle: {
      type: [Object, null],
      default: null
    },
    data: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      option: {
        color: this.color,
        title: {
          text: this.title,
          top: '3%',
          left: 'center',
          textStyle: {
            color: '#2bf2f4'
          }
        },
        tooltip: {
          trigger: 'axis',
          show: true
        },
        grid: {
          top: '18%',
          left: '5%',
          right: '8%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#6e7c85'
            }
          },
          axisLabel: {
            color: 'white'
          }
        },
        yAxis: {
          name: this.unit,
          type: 'value',
          nameTextStyle: {
            color: 'white'
          },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#425565'
            }
          },
          axisLabel: {
            color: 'white'
          }
        },
        series: [
          {
            type: 'line',
            smooth: true,
            ...(this.serieStyle || {})
          }
        ]
      }
    };
  },
  methods: {
    setOption(data) {
      if (Array.isArray(data)) {
        this.$set(this.option.series[0], 'data', data);
      } else if (typeof data === 'object') {
        this.$set(this, 'baseOption', Object.assign(this.option, data));
      }
    }
  },
  watch: {
    data: {
      handler: 'setOption',
      immediate: true,
      deep: true
    }
  }
};
</script>
